import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Watch, Prop, ProvideReactive } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import commonMixins from "@mixins/commonNewMixins";
import questionSet from "./index.vue";
import questionSubmitSet from "../questionnaireSubmitSet/index.vue";
import templateTitleDialog from "./templateTitleDialog.vue";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import { service } from "@modules/newCommunity/setup";
let QuestionnaireEditorCore = class QuestionnaireEditorCore extends mixins(commonMixins) {
  constructor() {
    super(...arguments);
    this.templateMode = false;
    this.localSubmit = {};
    this.postForm = {
      title: "标题"
    };
    this.submitLoading = false;
    this.activeIndex = 1;
    this.dataInited = false;
    this.templateTitleDialogVisible = false;
    this.templateEditingId = "";
  }
  get rules() {
    return {
      title: [{
        required: true,
        type: "string",
        message: "请输入" + this.surveyConfig.label,
        trigger: "blur"
      }]
    };
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get isAnswerMode() {
    return this.questionnaireType == "ANSWER";
  }
  get basicDataUniqueId() {
    return QuestionnaireEditModule.basicDataUniqueId;
  }
  get VUE_APP_WEN_LINK() {
    return process.env.VUE_APP_WEN_LINK;
  }
  get basicData() {
    return QuestionnaireEditModule.basicData;
  }
  get isModel() {
    return QuestionnaireEditModule.isModel;
  }
  watchPropData() {
    if (JSON.stringify(this.basicData) != JSON.stringify(this.localSubmit)) {
      const backup = JSON.parse(JSON.stringify(this.basicData));
      this.localSubmit = JSON.parse(JSON.stringify(backup));
      this.postForm = backup;
      this.clearValidate();
    }
  }
  // 向外层同步步骤和模式状态，供两种承载层复用操作栏
  emitStateChange() {
    const state = {
      activeIndex: this.activeIndex,
      isAnswerMode: this.isAnswerMode,
      isViewMode: this.isModel === "VIEW",
      submitLoading: this.submitLoading
    };
    this.$emit("state-change", state);
  }
  setActiveIndex(activeIndex) {
    this.activeIndex = activeIndex;
    this.emitStateChange();
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
  // 初始化共享问卷状态，保持原弹窗的数据装载顺序
  async initQuestionnaire(questionnaireId = "") {
    this.dataInited = false;
    this.setActiveIndex(1);
    this.postForm.title = "";
    QuestionnaireEditModule.SET_RESET_STORE();
    QuestionnaireEditModule.SET_showVerificationConfig(this.showVerificationConfig);
    QuestionnaireEditModule.SET_isModel(this.openMode || "");
    QuestionnaireEditModule.SET_editSpecialMode(this.editSpecialMode || "");
    QuestionnaireEditModule.SET_QUESTIONNAIRESOURCE_DATA("DOCTOR");
    QuestionnaireEditModule.SET_QUESTIONTYPE_PROPERTY(this.activityQuestionnaireProperty);
    QuestionnaireEditModule.SET_QUESTIONTYPE_DATA(this.activityQuestionnaireType);
    if (questionnaireId || this.questionnaireId) {
      QuestionnaireEditModule.SET_BASICDATA_ID(questionnaireId || this.questionnaireId);
      await QuestionnaireEditModule.GET_QUESTIONNAIRE_DETAIL(questionnaireId || this.questionnaireId);
    }
    if (this.showVerificationConfig) {
      QuestionnaireEditModule.SET_verificationConfig_verificationLogicSwitch("INFO");
    } else {
      QuestionnaireEditModule.SET_verificationConfig_verificationLogicSwitch("DISABLE");
    }
    this.dataInited = true;
    this.emitStateChange();
  }
  async saveTemp() {
    if (this.isModel == "VIEW") {
      window.open(`${this.VUE_APP_WEN_LINK}/medic/nsurvey/${this.questionnaireId}?pageMode=preview`, "_blank", "height=800, width=375, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no");
      return;
    }
    const result = await this.$refs.questionSet.CHECK_DATA_validate();
    if (!result) return;
    const saveRes = await QuestionnaireEditModule.SAVE_QUESTIONNAIRE(this.basicDataUniqueId || "");
    this.submitLoading = false;
    this.emitStateChange();
    if (saveRes && saveRes.data && saveRes.code == 200) {
      QuestionnaireEditModule.SET_BASICDATA_ID(saveRes.data);
      QuestionnaireEditModule.GET_QUESTIONNAIRE_DETAIL(saveRes.data);
      window.open(`${this.VUE_APP_WEN_LINK}/medic/nsurvey/${saveRes.data}?pageMode=preview`, "_blank", "height=800, width=375, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no");
    }
  }
  async nextStepToTemple() {
    let result = false;
    if (this.activeIndex == 2) {
      result = await this.$refs.questionSet.CHECK_DATA_validate();
    }
    if (this.activeIndex == 3) {
      result = await this.$refs.questionSubmitSet.CHECK_DATA_validate();
    }
    if (!result) return;
    this.templateEditingId = "";
    if (this.templateId) {
      const refreshNew = await this.$confirm("该表单已经创建过模板，请选择是否需要更新原模板", "提示", {
        confirmButtonText: "更新",
        cancelButtonText: "创建新模板",
        distinguishCancelAndClose: true,
        type: "warning"
      }).then(() => {
        return "update";
      }).catch(action => {
        return action == "cancel" ? "new" : "close";
      });
      if (refreshNew == "update") {
        this.templateEditingId = this.templateId;
        await this.templateTitleDialogSuccess("");
      } else if (refreshNew == "new") {
        this.templateTitleDialogVisible = true;
      }
    } else {
      this.templateTitleDialogVisible = true;
    }
  }
  async templateTitleDialogSuccess(title) {
    const questionnaireId = await this.handleCommit("template");
    if (!questionnaireId) return;
    const templateRes = await service.questionnaireGenerationTemplate({
      questionnaireId,
      formTemplateId: this.templateEditingId,
      title: title || undefined
    });
    this.$emit("template-success", templateRes.data, {
      questionnaireId,
      title: this.basicData.title
    });
  }
  async nextStep() {
    if (this.activeIndex == 1) {
      const result = await this.$refs.postForm.validate();
      if (result) {
        const backup = JSON.parse(JSON.stringify(this.postForm));
        QuestionnaireEditModule.SET_BASIC_LIST(backup);
        this.setActiveIndex(this.activeIndex + 1);
      }
      return;
    }
    if (this.activeIndex == 2) {
      const result = await this.$refs.questionSet.CHECK_DATA_validate();
      if (!result) return;
      if (this.isAnswerMode) {
        this.setActiveIndex(this.activeIndex + 1);
      } else {
        await this.handleCommit();
      }
      return;
    }
    const result = await this.$refs.questionSubmitSet.CHECK_DATA_validate();
    if (result) {
      await this.handleCommit();
    }
  }
  preNextClick() {
    this.setActiveIndex(this.activeIndex - 1);
  }
  // 保存后只抛出业务结果，由外层决定关闭弹窗或通知 iframe 宿主
  async handleCommit(submitScene = "submit") {
    try {
      const data = await QuestionnaireEditModule.SAVE_QUESTIONNAIRE(this.basicDataUniqueId || "");
      this.submitLoading = false;
      this.emitStateChange();
      if (!data || !data.data || data.code != 200) {
        this.$message.error(data && data.message ? data.message : "提交失败");
        return "";
      }
      const questionnaireData = await QuestionnaireEditModule.GET_QUESTIONNAIRE_DETAIL(data.data);
      this.$message.success("提交成功");
      if (this.isAnswerMode) {
        const params = {
          templateId: "",
          title: this.basicData.title,
          questionnaireId: data.data,
          totalScore: this.basicData.totalScore,
          resultList: questionnaireData.resultList
        };
        this.$emit("success", params, submitScene);
      } else {
        const params = {
          templateId: "",
          title: this.basicData.title,
          questionnaireId: data.data,
          participateUniqueCheck: questionnaireData.participateUniqueCheck,
          participateRepeatedClassId: questionnaireData.participateRepeatedClassId,
          participateRepeatedClassName: questionnaireData.participateRepeatedClassName
        };
        this.$emit("success", params, submitScene);
      }
      return data.data;
    } catch (error) {
      this.submitLoading = false;
      this.emitStateChange();
      return "";
    }
  }
  mounted() {
    this.emitStateChange();
  }
};
__decorate([ProvideReactive()], QuestionnaireEditorCore.prototype, "templateMode", void 0);
__decorate([Prop({
  default: true
})], QuestionnaireEditorCore.prototype, "active", void 0);
__decorate([Prop({
  default: ""
})], QuestionnaireEditorCore.prototype, "questionnaireId", void 0);
__decorate([Prop({
  default: ""
})], QuestionnaireEditorCore.prototype, "templateId", void 0);
__decorate([Prop({
  default: "ADD"
})], QuestionnaireEditorCore.prototype, "openMode", void 0);
__decorate([Prop({
  default: ""
})], QuestionnaireEditorCore.prototype, "editSpecialMode", void 0);
__decorate([Prop({
  default: "QUESTIONNAIRE"
})], QuestionnaireEditorCore.prototype, "activityQuestionnaireType", void 0);
__decorate([Prop({
  default: "QUESTIONNAIRE"
})], QuestionnaireEditorCore.prototype, "activityQuestionnaireProperty", void 0);
__decorate([Prop({
  default: false
})], QuestionnaireEditorCore.prototype, "showVerificationConfig", void 0);
__decorate([Prop({
  default: () => {
    return {
      title: "自定义表单",
      label: "表单名称",
      type: "ACTIVITY"
    };
  }
})], QuestionnaireEditorCore.prototype, "surveyConfig", void 0);
__decorate([Watch("basicData", {
  deep: true,
  immediate: true
})], QuestionnaireEditorCore.prototype, "watchPropData", null);
QuestionnaireEditorCore = __decorate([Component({
  name: "QuestionnaireEditorCore",
  components: {
    questionSet,
    questionSubmitSet,
    templateTitleDialog
  }
})], QuestionnaireEditorCore);
export default QuestionnaireEditorCore;